import axios from 'axios';
import {
  API_LOYALTY,
  API_SERVER_WS,
  API_SERVER_WS_V2,
  API_SERVER_WSS,
  LINK_DEV,
  TOKEN_OCR,
} from 'constants/index';
import cryptoJs from 'crypto-js';
import { clearStorage, getAuth, setAuth, clearCookies } from 'functions';
import { handleLogout, httpStatus } from 'model/constants/variableConstant';

export function decryptedAuth(data) {
  const decryptedData = cryptoJs.AES.decrypt(data, 'PcGGH@3^EhV@rywK', {
    keySize: 128 / 8,
    iv: 'PcGGH@3^EhV@rywK',
    mode: cryptoJs.mode.CBC,
    padding: cryptoJs.pad.Pkcs7,
  });
  return cryptoJs.enc.Utf8.stringify(decryptedData);
}

const queryApi = (baseUrl = API_SERVER_WS, configHeaders = {}) => {
  const instance = axios.create({
    baseURL: baseUrl,
    timeout: 600000,
  });

  instance.interceptors.request.use(
    (config) => {
      const auth = () => {
        const v = getAuth();
        if (!!v) {
          return v;
        }
        if (
          window.location.pathname === '/' &&
          !!window.location.search &&
          !!window.location.search.split('?token=')[1] &&
          !v
        ) {
          const valueAuth = decryptedAuth(
            decodeURIComponent(window.location.search.split('?token=')[1])
          );
          setAuth(valueAuth);
          return JSON.parse(valueAuth);
        }
        return null;
      };
      if (auth()?.token) {
        config.headers.Authorization = auth().token;
        config.headers['Content-Type'] = 'application/json';
      }

      Object.keys(configHeaders).forEach((item) => {
        config.headers[item] = configHeaders[item];
      });

      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(undefined, (error) => {
    try {
      const { response } = error;
      if (response?.status === httpStatus.unauthorized) {
        clearCookies();
        // window.location.href = LINK_DEV;
        // window.location.href =`${LINK_DEV}/?logout`;
      } else {
        // window.location.href ='/pages/error-page';
      }
    } catch (error) {}
  });
  return instance;
};

const config = {
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
};

const configOCR = {
  'Content-Type': 'application/json',
  Authorization: TOKEN_OCR,
};

export const axiosInstance = queryApi(API_SERVER_WS);
export const axiosLoyalty = queryApi(API_LOYALTY);
export const axiosInstanceV2 = queryApi(API_SERVER_WS_V2);
export const axiosInstanceV3 = queryApi(API_SERVER_WSS);
export const queryClaimOnline = queryApi(API_SERVER_WSS);
export const queryGoogleCaptcha = queryApi('https://www.google.com/recaptcha/', config);

export default axiosInstance;
